<template>
    <div>
        <content-view >
        <!-- 渠道管理-操作记录 -->
        <div slot="header">
            <a-form :form="filterForm" layout="inline" class="store-one-form">
                <a-form-item label="修改日期">
                    <a-date-picker format="YYYY-MM-DD" v-decorator="['modifyDate', {initialValue: defaultValue}]"/>
                </a-form-item>
                <a-form-item label="修改人">
                    <a-input v-decorator="['modifier']" placeholder="请输入"></a-input>
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button :loading="searchLoading" type="primary" @click="search">筛选</a-button>
                    <a-button :loading="searchLoading" @click="handleReset()">重置</a-button>
                </a-form-item>
            </a-form>
        </div>
        <div class="wrap-container-in">
            <a-table
            bordered
            :dataSource="warehouse"
            :columns="columns"
            :pagination="pagination"
            :rowKey="record => record.id"
            @change="changePage"
            :loading="searchLoading"
            >
                <span slot="index" slot-scope="a,b,index">{{index+1}}</span>
                <span slot="happenTime" slot-scope="happenTime">{{happenTime ? happenTime.replace('T',' ') : "-"}}</span>
                <span slot="createTime" slot-scope="createTime">{{createTime ? createTime.replace('T',' ') : "-"}}</span>
                <span slot="remark" slot-scope="remark">{{remark ? remark : "-"}}</span>
            </a-table>
        </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import moment from 'moment'
    export default {
        name: 'channel',
        components: {},
        props: {},
        data() {
            const columns = [
                {
                    title: '序号',
                    dataIndex: 'index',
                    scopedSlots: { customRender: "index" }
                },
                {
                    title: '操作订单',
                    dataIndex: 'orderId'
                },
                {
                    title: '订单发生时间',
                    dataIndex: 'happenTime',
                    scopedSlots: { customRender: "happenTime" }
                },
                {
                    title: '订单操作人',
                    dataIndex: 'cashier'
                },
                {
                    title: '修改前金额',
                    dataIndex: 'beforeAmount'
                },
                {
                    title: '修改后金额',
                    dataIndex: 'afterAmount'
                },
                {
                    title: '修改人',
                    dataIndex: 'modifier'
                },
                {
                    title: '修改时间',
                    dataIndex: 'createTime',
                    scopedSlots: { customRender: "createTime" }
                },
                {
                    title: "备注",
                    dataIndex: "remark",
                    scopedSlots: { customRender: "remark" }
                },
            ];
            return {
                columns,
                warehouse: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                filterForm: this.$form.createForm(this), //筛选表单
                defaultValue: moment(),
                comfirmMemberList: [],
                searchLoading: false
            };
        },
        beforeCreate() {},
        watch: {},
        computed: {},
        methods: {
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            // 重置筛选
            handleReset() {
                this.filterForm.resetFields();
                this.getList();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            //修改人
            comfirmMember() {
                this.$api.storage.comfirmMember({params: {
                    shopId: this.$store.state.platform.shopId
                }}).then(res => {
                    this.comfirmMemberList = res;
                });
            },
            //获取列表
            getList() {
                if (this.searchLoading) {
                    return false;
                }
                this.filterForm.validateFields((err, values) => {
                    if (err) return;
                    values.modifyDate = moment(values.modifyDate).format('YYYY-MM-DD')
                    this.searchLoading = true;
                    this.$api.financial.operateList({ body: {
                        ...values,
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize
                    } }).then(res => {
                        this.searchLoading = false;
                        this.warehouse = res.data;
                        this.pagination.total = res.total;
                    }).catch((err) => {
                        this.searchLoading = false;
                    });
                })
            },
        },
        created() {},
        mounted() {
            this.getList();
            this.comfirmMember();
        },
        watch: {}
    };
</script>
<style lang="scss">
</style>